import qs from 'query-string'
import { encodeURI } from 'js-base64'
import axios from 'axios'
import { message, Modal } from 'antd'
import $ from 'jquery'
import { isEmpty } from 'lodash'
import store from '@store'
import { logout as logoutAction } from '@actions/basic/user'
import * as Storage from '@utils/storage'
import gateway from '@enum/gateway'
import { catchRequestError } from '@utils/sentry'
import config from '@/config/app'

const ENABLE_ENCODE_QS = !['dev', 'daily'].find(
  i => i === process.env.CONFIG_ENV
)
/**
 * @param {Record<string, any>} v
 * @returns {string}
 */
export const queryStringify = (v, force = false) =>
  ENABLE_ENCODE_QS || force ? encodeURI(qs.stringify(v)) : qs.stringify(v)

const contentTypes = {
  1: 'application/x-www-form-urlencoded;charset=utf-8',
  2: 'multipart/form-data',
  3: 'application/json'
}

/**
 *错误的信息定义
 */
const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '当前账号缺少此操作权限，或所选数据不在授权范围内。',
  404: '发出的请求对的,但是服务器中不存在此条请求地址，请求返回404',
  405: '向服务端发送请求的方式错误,请检查之后再进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。'
}

let configs = {
  headers: {
    'Content-type': contentTypes[3]
  }
}

let modalShow = false

// 自动退出登录
const logout = () => {
  store.dispatch(logoutAction('autoGoBack'))
}

const itAxios = axios.create({
  timeout: 30000,
  withCredentials: false,
  baseURL: config.globalVariable.gateway,
  validateStatus: status => {
    return status < 600
  },
  ...configs
})

/**
 * url 参数处理
 * @param {*} url
 * @param {*} args
 * @returns
 */
const formatParameter = (url, args) => {
  let obj = {}
  if (args) {
    Object.keys(args).forEach(key => {
      if (url.indexOf(`{${key}}`) > -1) {
        url = url.replace(`{${key}}`, args[key])
      } else {
        obj[key] = args[key]
      }
    })
  }
  return {
    url: url,
    args: obj
  }
}

/**
 * ajax 公用方法
 * @param {String} method 请求方式
 * @param {String} [url=''] 请求的URL
 * @param {Object} [args={}] 请求参数
 * @param {} [config=configs] 请求头类型设置
 * @returns
 */
const ajax = (method, url = '', args = null, config = {}) => {
  let response = {}
  let cgs = {
    headers: {
      ...configs.headers,
      ...config
    }
  }
  try {
    if (method === 'delete') {
      response = itAxios.delete(url, { ...cgs, data: args })
    } else {
      response = itAxios[method](url, args, cgs)
    }
  } catch (e) {
    response = e.response
  }
  return response
}

const request = {
  /**
   *  get 请求
   * @param {String} url 请求url 如: '/api/user/{id}/info', 禁止向后追加参数,如/api/user/{id}/info?id={id}
   * @param {Object} args
   * @param {Boolean} [authorize=false] 是否关闭API权限验证
   * @returns Promise
   */
  fetch: (url, args, authorize = false, hasArgs) => {
    let param = formatParameter(url, args)
    url = `${param.url}${
      !isEmpty(args) ? `?${queryStringify(param.args)}` : ''
    }`
    let queryUrl = param.url + '?' + queryStringify(args)
    return ajax('get', hasArgs ? queryUrl : url, hasArgs ? args : null, {
      authorize
    })
  },
  /**
   *  post 请求
   * @param {String} url 请求url 如: '/api/user/{id}/info'
   * @param {Object} args 请求参数
   * @param {Boolean} [authorize=false] 是否关闭API权限验证
   * @returns Promise
   */
  post: (url, args, authorize = false) => {
    let param = formatParameter(url, args)
    return ajax('post', param.url, param.args, { authorize })
  },
  /**
   * @param {String} url 请求url 如: '/api/user/{id}/info?rid={rid}'
   * @param {Object} args 请求参数
   * @param {Boolean} [authorize=false] 是否关闭API权限验证
   * @returns Promise
   */
  put: (url, args, authorize = false) => {
    let param = formatParameter(url, args)
    return itAxios.put(param.url, param.args, { authorize })
  },
  /**
   * patch 请求
   * @param {String} url 请求url 如: '/api/user/{id}/info?rid={rid}'
   * @param {Object} args 请求参数
   * @param {Boolean} [authorize=false] 是否关闭API权限验证
   * @returns Promise
   */
  patch: (url, args, authorize = false) => {
    let param = formatParameter(url, args)
    if (param.args) {
      param.args = JSON.stringify(param.args)
    }
    return ajax('patch', param.url, param.args, { authorize })
  },
  /**
   * patch 请求
   * @param {String} url 请求url 如: '/api/user/{id}/info?rid={rid}'
   * @param {Object} args 请求参数
   * @param {Boolean} [authorize=false] 是否关闭API权限验证
   * @returns Promise
   */
  patchUrlParams: (url, args, authorize = false) => {
    let param = formatParameter(url, args)
    if (param.args) {
      param.args = JSON.stringify(param.args)
    }
    let queryUrl = param.url + '?' + $.param(args)
    return ajax('patch', queryUrl, null, { authorize })
  },
  /**
   * delete 请求
   * @param {String} url 请求url 如: '/api/user/{id}/info?rid={rid}'
   * @param {Object} args 请求参数
   * @param {Boolean} [authorize=false] 是否关闭API权限验证
   * @returns Promise
   */
  delete: (url, args, authorize = false, data = {}, contentTypesCode) => {
    let headers = {}
    const contentType = contentTypes[contentTypesCode]
    if (contentType) {
      // Preserve the Axios default when the caller does not request an override.
      headers['Content-type'] = contentType
    }
    let param = formatParameter(url, args)
    if (param.args && Object.keys(param.args).length) {
      url = `${param.url}?${queryStringify(param.args)}`
    } else {
      url = `${param.url}`
    }
    return ajax('delete', url, null, { ...headers, authorize })
  },
  /**
   * delete 请求
   * @param {String} url 请求url 如: '/api/user/{id}/info?rid={rid}'
   * @param {Object} args 请求参数
   * @param {Boolean} [authorize=false] 是否关闭API权限验证
   * @returns Promise
   */
  deleteWithBody: (
    url,
    args,
    authorize = false,
    data = {},
    contentTypesCode
  ) => {
    let headers = {}
    const contentType = contentTypes[contentTypesCode]
    if (contentType) {
      // An undefined MIME type is rejected by the gateway before routing.
      headers['Content-type'] = contentType
    }
    let param = formatParameter(url, args)
    return ajax('delete', url, args, { ...headers, authorize })
  },
  /**
   * formData 形式请求
   * @param {*} url  '/api/user/{id}/info?rid={rid}'
   * @param {*} args 请求参数自动转化为FormData
   * @param {Boolean} [authorize=false] 是否关闭API权限验证
   * @returns Promise
   */
  formData: (url, args, authorize = false) => {
    let param = formatParameter(url, args)
    let formData = new FormData()
    Object.keys(args).forEach(key => {
      formData.append(key, args[key])
    })
    return ajax('post', param.url, formData, {
      'Content-type': contentTypes[2],
      authorize
    })
  },
  /**
   * formDataArr 形式请求(多图上传的特殊处理)
   * @param {*} url  '/api/user/{id}/info?rid={rid}'
   * @param {*} args 请求参数为数组格式,自动转化为FormData
   * @param {Boolean} [authorize=false] 是否关闭API权限验证
   * @returns Promise
   */
  formDataArr: (url, args, authorize = false) => {
    let param = formatParameter(url, args)
    let formData = new FormData()
    args.forEach(file => {
      formData.append('files', file)
    })
    return ajax('post', param.url, formData, {
      'Content-type': contentTypes[2],
      authorize
    })
  },
  _formData: (method, url, args, authorize = false) => {
    const param = formatParameter(url, args)
    const formData = new FormData()
    Object.keys(param.args).forEach(key => {
      formData.append(key, args[key])
    })
    return ajax(method, param.url, formData, {
      'Content-type': contentTypes[2],
      authorize
    })
  },
  ajax: (
    method,
    url = '',
    args = null,
    config = Object.assign({}, configs)
  ) => {
    return ajax(method, url, args, config)
  },
  /**
   * 自定义请求方式
   * @param {Object} config {method, url, params, config}
   * @returns
   */
  request: config => {
    return itAxios.request(config)
  }
}
itAxios.interceptors.request.use(
  config => {
    // 服务端通过请求头判断是否需要编码
    if (ENABLE_ENCODE_QS && ['get', 'delete'].indexOf(config.method) >= 0) {
      config.headers['enable-ac-policy'] = true
    }
    if (config.headers.authorize) {
      config.headers['Authorize'] = true
    } else {
      config.headers.token = Storage.getItem('token') || ''
    }
    delete config.headers.authorize
    return config
  },
  err => {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.error({
      error: err
    })
  }
)

itAxios.interceptors.response.use(
  response => {
    let { status, data = null, request } = response
    let { responseURL } = request
    if ((status === 401 || data.code === 401) && !modalShow) {
      modalShow = true
      Modal.warning({
        centered: true,
        okText: '返回登录页',
        maskClosable: false,
        title: '系统提示',
        content: '您当前登录的账户已失效, 请重新登录!',
        onOk() {
          logout()
        }
      })
      return false
    }

    // 4.x.x 版本*所有服务*响应处理
    const statusCode =
      parseInt(data.errCode) || data.code || status || data.status
    // Reject transport failures while preserving legacy HTTP 200 business code 400 responses.
    if (!response || status >= 400 || statusCode > 400) {
      console.error(
        '⚠️⚠️⚠️⚠️⚠️ 来自服务端(API)的报错(Error)信息 ⚠️⚠️⚠️⚠️: %o',
        data || response
      )

      const errortext =
        data.errMessage ||
        data.message ||
        codeMessage[statusCode] ||
        '获取数据失败，请刷新再试试！'
      message.error(errortext)
      return catchRequestError(
        response,
        new Error([statusCode, errortext].join('@'))
      )
    }

    // 5.x.x 版本*新增服务*响应处理
    const { essentialService, member2 } = gateway
    if (
      (responseURL.indexOf(essentialService) > 0 ||
        responseURL.indexOf(member2) > 0) &&
      !data?.success
    ) {
      // 服务端返回的 错误现象不统一
      const msg = data.errMessage || data.message
      message.error(msg)
      return catchRequestError(
        response,
        new Error(`来自服务端(API)的报错(Error)信息: ${msg}`)
      )
    }
    return data
  },
  e => {
    console.error('⚠️⚠️⚠️⚠️⚠️ 来自服务端(API)的报错(Error)信息 ⚠️⚠️⚠️⚠️: %o', e)
    return Promise.reject(e)
  }
)

export default request
